// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPut, BASE_URL, retrieveToken } from "../../store/api";
import { StatusKerjasamaUpdateResponse } from "./types";

import * as statusKerjasamaActions from "./statusKerjasama.actions";
import { showModal } from "../modal/modal.actions";

export function* updateStatusKerjasama(
  action: ReturnType<typeof statusKerjasamaActions.updateStatusKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `status-kerjasama/${action.payload.STATUS_ID}`;
    const result: Response = yield call(apiPut, url, token, action.payload);

    if (result.status === 200) {
      const parsed: StatusKerjasamaUpdateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'))
      yield put(statusKerjasamaActions.updateStatusKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(statusKerjasamaActions.updateStatusKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(statusKerjasamaActions.updateStatusKerjasamaAsync.failure(parsed));
  }
}

export default function* statusKerjasamaSagaUpdateStatusKerjasama() {
  yield takeEvery(statusKerjasamaActions.updateStatusKerjasamaAsync.request, updateStatusKerjasama);
}
